import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import userReducer from './userSlice';
import employeesReducer from './employeesSlice';
import dashboardReducer from './dashboardSlice';
import dataSourcesReducer from './dataSourcesSlice';
import filtersReducer from './filtersSlice';
import drilldownReducer from './drilldownSlice';
import enhancedFiltersReducer from './enhancedFiltersSlice';
import stateSyncMiddleware from '../middleware/stateSyncMiddleware';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    employees: employeesReducer,
    dashboard: dashboardReducer,
    dataSources: dataSourcesReducer,
    filters: filtersReducer,
    drilldown: drilldownReducer,
    enhancedFilters: enhancedFiltersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these paths for date objects in filters, drilldown, and auth
        ignoredPaths: [
          'filters.filters.dateRange', 
          'drilldown.data.trends', 
          'drilldown.data.individuals',
          'auth.user.lastActivity',
          'auth.sessionExpiry'
        ],
        ignoredActions: [
          'filters/setFilter', 
          'filters/setFilters', 
          'drilldown/fetchData/fulfilled', 
          'drilldown/navigate/fulfilled',
          'auth/login/fulfilled',
          'auth/loginWithOAuth/fulfilled',
          'auth/refreshToken/fulfilled',
          'auth/initializeAuth/fulfilled',
          'dashboard/updateMetrics',
          'dashboard/updateFilteredCount',
          'employees/applyRoleFilter',
          'dashboard/applyRoleConfig',
          'filters/updateFilterOptions'
        ],
      },
    }).concat(stateSyncMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;